// src/pages/TwoFactorAuthModePage.jsx
import React, { useEffect, useState } from "react";
import api from "../api/api";
import twoFactorService from "../api/twoFactorService";

const TwoFactorAuthModePage = () => {
    const [qrUrl, setQrUrl] = useState(null);
    const [code, setCode] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [isEnabled, setIsEnabled] = useState(false);

    // =========================
    // Load 2FA status
    // =========================
    const loadStatus = async () => {
        try {
            const res = await api.get("/login/me");
            setIsEnabled(res.data.isTwoFactorEnabled === true);
        } catch (e) {
            console.error("Failed to load 2FA status:", e);
        }
    };

    
    // =========================
    // Generate QR (setup)
    // =========================
    const handleGenerateQr = async () => {
        setError("");
        setMessage("");

        try {
            setLoading(true);
            setQrUrl(null);

            const url = await twoFactorService.setup2FA();
            setQrUrl(url);

            setMessage("📷 Scan the QR code with Google Authenticator.");
        } catch (e) {
            console.error(e);
            setError("❌ Failed to generate QR code.");
        } finally {
            setLoading(false);
        }
    };

    // =========================
    // Confirm 2FA
    // =========================
    const handleConfirmCode = async () => {
        setError("");
        setMessage("");

        if (!code.trim()) {
            setError("Please enter the 2FA code.");
            return;
        }

        try {
            setLoading(true);
            await twoFactorService.confirm2FA(code.trim());

            setMessage("✅ Two-factor authentication enabled.");
            setCode("");
            setQrUrl(null);

            await loadStatus();
        } catch (e) {
            console.error(e);
            setError("❌ Invalid 2FA code.");
        } finally {
            setLoading(false);
        }
    };

    // =========================
    // Disable 2FA
    // =========================
    const handleDisable2FA = async () => {
        setError("");
        setMessage("");

        try {
            setLoading(true);
            await twoFactorService.disable2FA();

            if (qrUrl) URL.revokeObjectURL(qrUrl);
            setQrUrl(null);

            setMessage("🛑 Two-factor authentication disabled.");
            await loadStatus();
        } catch (e) {
            console.error(e);
            setError("❌ Failed to disable 2FA.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 20, maxWidth: 420 }}>
            <h2>Two-Factor Authentication</h2>

            <div style={{ marginTop: 12 }}>
                <strong>Status:</strong>{" "}
                {isEnabled ? "🟢 Enabled" : "🔴 Disabled"}
            </div>

            {!isEnabled && (
                <div style={{ marginTop: 12 }}>
                    <button onClick={handleGenerateQr} disabled={loading}>
                        Generate QR for 2FA
                    </button>
                </div>
            )}

            {isEnabled && (
                <div style={{ marginTop: 12 }}>
                    <button onClick={handleDisable2FA} disabled={loading}>
                        Disable 2FA
                    </button>
                </div>
            )}

            {qrUrl && (
                <div style={{ marginTop: 20 }}>
                    <img src={qrUrl} alt="2FA QR" />
                </div>
            )}

            {!isEnabled && qrUrl && (
                <div style={{ marginTop: 20 }}>
                    <label>Authenticator code</label>
                    <input
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Enter code from app"
                        style={{ display: "block", width: "100%", marginTop: 6 }}
                    />
                    <button onClick={handleConfirmCode} disabled={loading} style={{ marginTop: 8 }}>
                        Confirm & Enable 2FA
                    </button>
                </div>
            )}

            {loading && <div style={{ marginTop: 10 }}>Processing…</div>}
            {error && <div style={{ color: "red", marginTop: 10 }}>{error}</div>}
            {message && <div style={{ color: "green", marginTop: 10 }}>{message}</div>}
        </div>
    );
};

export default TwoFactorAuthModePage;
